module.exports = __webpack_public_path__ + "static/media/logo.f44c498d.svg";